export default __webpack_public_path__ + "static/media/h26koritu.60b1c3f2.mp3";